import { Controller } from "@hotwired/stimulus";

// Simple currency formatting for display - Money concern handles conversion
export default class extends Controller {
  static targets = ["input"];

  connect() {
    this.inputElement = this.inputTarget || this.element.querySelector("input");
    if (!this.inputElement) return;

    this.onInput = this.onInput.bind(this);
    this.onBlur = this.onBlur.bind(this);

    this.inputElement.addEventListener("input", this.onInput);
    this.inputElement.addEventListener("blur", this.onBlur);
  }

  disconnect() {
    if (!this.inputElement) return;
    this.inputElement.removeEventListener("input", this.onInput);
    this.inputElement.removeEventListener("blur", this.onBlur);
  }

  onInput() {
    this.formatDisplay();
  }

  onBlur() {
    this.formatDisplay(true);
  }

  formatDisplay(forceTwoDecimals = false) {
    if (!this.inputElement) return;
    const raw = this.inputElement.value || "";

    // Allow typing without forcing format until blur
    if (!forceTwoDecimals) return;

    const digits = raw.replace(/[^0-9.]/g, "");
    const num = parseFloat(digits);
    if (isNaN(num)) {
      this.inputElement.value = "";
      return;
    }
    this.inputElement.value = num.toFixed(2);
  }
}
